import React from 'react';
import "./About.css";
import HowItWorks from '../../components/How-it-works/HowItWorks';

const About = () => {
  return (
    <div className='about'>
      <HowItWorks />
    </div>
  )
}

export default About
